import { PermissionCode } from "@/constants/permissions";
import { AppRoutes } from "@/constants/routes";
import { Permiso } from "@/pages/role-asignation/schema/role-assignation.schema";
import { Flex, Link } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

interface Props {
  permissions: Permiso[];
}

export const GrainRequestsView = ({ permissions }: Props) => {
  const navigate = useNavigate();
  const hasAccess = (codigo: string) =>
    permissions?.some((p) => p.codigo === codigo && p.tipoPermiso === "R");

  const canUseSellOrders = hasAccess(PermissionCode.GRAIN_SELL_ORDER);
  const canUseGrainDeliveryPayments = hasAccess(
    PermissionCode.COUNTER_DELIVERY,
  );

  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">
      {canUseSellOrders && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.SELL_ORDERS)}>
          Órdenes de venta
        </Link>
      )}
      {canUseGrainDeliveryPayments && (
        <Link
          variant="plain"
          onClick={() => navigate(AppRoutes.GRAIN_DELIVERY_PAYMENTS)}
        >
          Contra entrega
        </Link>
      )}
    </Flex>
  );
};
